<template>
  <div class="relative">
    <ConnectionInform />
    <iframe
      v-if="getHackathonSlide"
      :src="`${getHackathonSlide.canvasUrl}?presentationId=${presentation.id}&slideId=${slideActive.id}&isPresenting=${isPresenting}`"
      frameborder="0"
      class="canvas-iframe"
    ></iframe>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ConnectionInform from '@/components-v2/presentation-editor/middle/connection/ConnectionInform.vue'
import { slideTypes } from '@/constant/slideTypes'

export default {
  components: {
    ConnectionInform,
  },
  props: {
  },
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),

    getHackathonSlide() {
      const index = slideTypes[0].slideTypes.findIndex((item) => item.slideType === this.slideActive.slideType)
      if (index !== -1) {
        return slideTypes[0].slideTypes[index]
      }
      return null
    },
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.canvas-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
}
</style>
